package gr.tech.GRAttestation.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ConfirmModal(
    modalId: String,
    confirmMessage: String,
    onConfirm: () -> Unit,
    onClose: () -> Unit,
) {
    Div(
        attrs = Modifier
            .classNames("modal", "fade")
            .id(modalId)
            .toAttrs {
                attr("tabindex", "-1")
                attr("data-bs-backdrop", "static")
            }
    ) {
        Div(
            attrs = Modifier.classNames("modal-dialog").toAttrs()
        ) {
            Div(
                attrs = Modifier.classNames("modal-content").toAttrs()
            ) {
                // Header
                Div(
                    attrs = Modifier.classNames("modal-header").toAttrs()
                ) {
                    H5(attrs = Modifier.classNames("modal-title").toAttrs()) {
                        Text("Confirm")
                    }
                    Button(
                        attrs = Modifier.classNames("btn-close").onClick { onClose() }.toAttrs {}
                    )
                }

                // Body
                Div(
                    attrs = Modifier.classNames("modal-body").toAttrs()
                ) {
                    P(
                        attrs = Modifier.fontFamily(FONT_FAMILY).fontSize(1.cssRem).color(Colors.Grey).toAttrs()
                    ) {
                        Text(confirmMessage)
                    }
                }

                // Footer
                Div(
                    attrs = Modifier.classNames("modal-footer").toAttrs()
                ) {
                    Button(
                        attrs = Modifier
                            .classNames("btn", "btn-outline-secondary")
                            .onClick { onClose() }
                            .toAttrs()
                    ) {
                        Text("Close")
                    }

                    Button(
                        attrs = Modifier.classNames("btn", "btn-primary")
                            .onClick { onConfirm() }
                            .toAttrs {}
                    ) {
                        Text("Confirm")
                    }
                }
            }
        }
    }
}


@Composable
fun ConfirmModalKobweb(
    actionText: String,
    subText: String = "",
    onConfirm: () -> Unit,
    onDismiss: () -> Unit
) {
    Box(
        modifier = Modifier
            .width(100.dvw)
            .height(100.dvh)
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .zIndex(19)
            .overflow(Overflow.Hidden)
        ,
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(700.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            H2(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.25.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text("Are you sure you want to '$actionText'?")
            }

            H3(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .margin(bottom = 6.px)
                    .toAttrs()
            ) {
                Text(subText)
            }

            Row(
                modifier = Modifier
                    .gap(16.px)
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Center
            ) {
                Button(
                    attrs = Modifier
                        .classNames("btn", "btn-primary")
                        .color(Colors.White)
                        .onClick {
                            onConfirm()
                        }
                        .toAttrs()
                ) {
                    Text("Confirm")
                }

                Button(
                    attrs = Modifier
                        .classNames("btn", "btn-secondary")
                        .color(Colors.White)
                        .onClick {
                            onDismiss()
                        }
                        .toAttrs()
                ) {
                    Text("Cancel")
                }
            }

        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}